import Text from '@cartwhl/ui/base/Text';
import ChevronRightIcon from '@cartwhl/ui/icons/ChevronRightIcon';

import type {
  ProfileSection,
  ProfileSectionSlug,
} from './profilePageSections';

export interface ProfileMobileMenuProps {
  sections: ProfileSection[];
  className?: string;
  onSelect: (slug: ProfileSectionSlug) => void;
}

export default function ProfileMobileMenu({
  sections,
  className,
  onSelect,
}: ProfileMobileMenuProps) {
  if (sections.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className="border-gray-30 dark:border-gray-60 divide-gray-30 dark:divide-gray-60 dark:bg-gray-90/30 overflow-hidden rounded-xl border bg-white shadow-sm">
        {sections.map((section, index) => (
          <button
            key={section.slug}
            type="button"
            className={`flex w-full items-center gap-3 px-4 py-4 text-left ${
              index > 0 ? 'border-gray-30 dark:border-gray-60 border-t' : ''
            }`}
            onClick={() => onSelect(section.slug)}
          >
            <Text variant="studio/body/medium/sm">{section.label}</Text>
            <ChevronRightIcon className="text-gray-45 dark:text-gray-30 ml-auto h-5 w-5 flex-none" />
          </button>
        ))}
      </div>
    </div>
  );
}
